import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js'
import contentTemplate from 'report/properties/style/gauge-needle-color.ejs';
import { pickerCfg } from 'pickerCfg';
import util             from 'util/Util.js';
import themeService     from 'ThemeService.js';

class StyleGaugeNeedleView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);
        
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=color]': 'updateColorAttributes',
            'change input[type=text]': 'updateColorAttributesWithValidation',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    render() {
        super.render();

        let props = this.model.toJSON();
        props.styleNeedleColor = themeService.resolve(props.styleNeedleColor) ;
        //console.log('on render on style ', props)
        this.$el.html(this.template(props));

        let that = this;

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.delegateEvents();

        return this;
    }

}

export default StyleGaugeNeedleView;
